var exports = {
  "I": "x31de4314--bbadfb--distance",
  "K": "x31de4314--bbadfb--icon",
};

module.exports = exports;
